import React, { useEffect } from "react";
import {
    styled,
    Box,
    Popper,
    Checkbox,
    TextField,
    Autocomplete,
    Divider,
    ClickAwayListener,
    AutocompleteCloseReason
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Skeleton from '@mui/material/Skeleton';
import axios from "../../../axios";
import api from "../../../api";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PopperStyledComponent = styled(Popper)(({ theme }) => ({
    border: `1px solid ${theme.palette.mode === "light" ? "rgba(149, 157, 165, 0.2)" : "rgb(1, 4, 9)"
        }`
}));

export default function CatalogCourseMultiSelect({ handleChangeCourses }) {
    const [loading, setLoading] = React.useState(true)
    const [value, setValue] = React.useState([]);
    const [checkAll, setCheckAll] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [courses, setCourses] = React.useState([])
    const config = { headers: { "x-auth-token": localStorage.getItem("user") } }

    const checkAllChange = (event) => {
        setCheckAll(event.target.checked);
        if (event.target.checked) {
            setValue(courses);
            handleChangeCourses(courses)
        } else {
            setValue([]);
            handleChangeCourses([])
        }
    };

    const handleClickAway = (e) => {
        setOpen(false);
    };

    async function getCatalogCourses() {
        const response = await axios.get(api.getAllCatalogCourse, config)
        setCourses(response.data)
        setLoading(false)
    }
    useEffect(() => {
        getCatalogCourses()
    }, [])

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box>
                {!loading && <Autocomplete
                    multiple
                    disableCloseOnSelect
                    limitTags={3}
                    id="checkboxes-tags-demo"
                    options={courses}
                    value={value}
                    open={open}
                    onChange={(event, newValue, reason) => {
                        if (reason === "selectOption") {
                            setValue(newValue);
                            handleChangeCourses(newValue)
                        } else if (reason === "removeOption") {
                            setCheckAll(false);
                            setValue(newValue);
                            handleChangeCourses(newValue)
                        } else if (reason === "clear") {
                            setValue([]);
                            handleChangeCourses([])
                            setCheckAll(false);
                        }
                    }}
                    onClose={(e, reason) => {
                        if (reason === "escape") {
                            setOpen(false);
                        }
                    }}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    PopperComponent={(param) => (
                        <PopperStyledComponent {...param}>
                            <Box {...param} />
                            <Divider />
                            <Box
                                sx={{
                                    backgroundColor: "white",
                                    height: "45px",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                <Checkbox
                                    checked={checkAll}
                                    onChange={checkAllChange}
                                    id="check-all"
                                    sx={{ marginRight: "8px" }}
                                    onMouseDown={(e) => e.preventDefault()}
                                />
                                Select All
                            </Box>
                        </PopperStyledComponent>
                    )}
                    getOptionLabel={(option) => option.title}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected || checkAll}
                            />
                            {option.title}
                        </li>
                    )}
                    style={{ width: "100%" }}
                    renderInput={(params) => (
                        <TextField {...params} label="Personal Course" placeholder="Courses" />
                    )}
                />}
                {loading && <Skeleton animation="wave" variant="rectangular" width={"100%"} height={60} />}
            </Box>
        </ClickAwayListener>
    );
}